<template>
    <v-container>
    <h2 class="text-h4">{{$t('auth.token.title')}}</h2>
    <v-alert
      v-if="success == null"
      border="left"
      colored-border
      type="info"
      elevation="2"
      class="mt-5"
    >{{$t('auth.token.text')}}</v-alert>
    <v-alert
      v-else-if="success == false"
      border="left"
      colored-border
      type="error"
      elevation="2"
      class="mt-5"
    >{{$t('auth.token.error')}}</v-alert>
    </v-container>
</template>
<script>
export default {
    name: 'Token',
    data() {
        return {
            success: null
        }
    },
    computed: {
        token() {
            return this.$route.params.token;
        }
    },
    created() {
        this.$store.dispatch('auth/requestAccess', {token: this.token}).then((result) => { this.success = result; if(this.success) { this.$router.push('/') }});
    }
}
</script>